import { sumBy } from './sumBy.mjs';

function sum(array) {
    return sumBy(array);
}

export { sum };
